module.exports = __webpack_public_path__ + "static/img/20231220_01.a3da907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231220_01.png
// module id = Dk7X
// module chunks = 0